define('editor/edit/actions/index',['durandal/app', 'plugins/router', 'plugins/http'], function (app, router, http) {
    var viewmodel = function () {
        var self = this;

        self.activate = function (editorMap) {
            self.editorMapId = editorMap.id;
            self.readOnly = editorMap.readOnly;
        };

        self.save = function () {
            var url = '/api/editor/save';
            return http.post(url, { id: self.editorMapId }).then(function (response) {
                if (!response.success) {
                    return app.showMessage(response.error, "Unable to save map");
                }
                app.trigger("editormap:saved");
                return app.showMessage('Saved');
            }).fail(app.showError);
        };

        self.backToList = function () {
            router.navigate('/editor/list');
        };
    };

    return viewmodel;
});

